var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42589 0.416217C1.87093 -0.138739 0.971172 -0.138739 0.416217 0.416217C-0.138739 0.971172 -0.138739 1.87093 0.416217 2.42589L6.99033 9L0.416217 15.5741C-0.138739 16.1291 -0.138739 17.0288 0.416217 17.5838C0.971172 18.1387 1.87093 18.1387 2.42589 17.5838L9 11.0097L15.5741 17.5838C16.1291 18.1387 17.0288 18.1387 17.5838 17.5838C18.1387 17.0288 18.1387 16.1291 17.5838 15.5741L11.0097 9L17.5838 2.42589C18.1387 1.87093 18.1387 0.971172 17.5838 0.416217C17.0288 -0.138739 16.1291 -0.138739 15.5741 0.416217L9 6.99033L2.42589 0.416217Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCrossIcon);
export default __webpack_public_path__ + "static/media/DeleteCrossIcon.6b24a608596eeb672143f43854bc1af6.svg";
export { ForwardRef as ReactComponent };